/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Pricing
 * The Selling Partner API for Pricing helps you programmatically retrieve product pricing and offer information for Amazon Marketplace products.
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Indicates the condition of the item. Possible values: New, Used, Collectible, Refurbished, Club.
 */

export const ConditionType = {
    New: 'New',
    Used: 'Used',
    Collectible: 'Collectible',
    Refurbished: 'Refurbished',
    Club: 'Club',
} as const;

export type ConditionType = typeof ConditionType[keyof typeof ConditionType];



